<style>
 .progress-bar {
     height: 20px;
     width: 100%;
     background: #999999;

 }
 .progress {
     margin-top: 1em;
     background: #999999;
     color: green;
 }

 progress::-webkit-progress-bar {background-color: #999999; width: 100%;}
 progress::-moz-progress-bar { background: green; }
 progress::-webkit-progress-value { background: green; }

 
 
 .control-fileupload label {
     color: #999999;
     font-weight: normal;
     overflow: hidden;
     white-space: nowrap;
     text-overflow: ellipsis;
     position: relative;
     z-index: 1;
     margin-right: 90px;
     margin-bottom: 0px;
     cursor: text;
 }
 input[type=file]{
     display: block !important;
     right: 1px;
     top: 1px;
     height: 34px;
     opacity: 0;
     width: 100%;
     background: none;
     position: absolute;
     overflow: hidden;
     z-index: 2;
 }
 .control-fileupload:before, .control-fileupload input, .control-fileupload label {
     cursor: pointer !important;
 }
 .control-fileupload {
     display: block;
     border: none;
     background: #fbf6f2;
     border-radius: 4px;
     width: 100%;
     line-height: 22px;
     padding: 0px;
     overflow: hidden;
     position: relative;
 }
 .control-fileupload label.custom-file-label{
     font-size: 24px;
     line-height: 36px;
     margin-top: 6px;
     width: 100%;
     
     color: #fff;
     background-color: #ffb718;
     font-family: corporate-s,sans-serif;
     font-weight: 700 !important;
     cursor: pointer !important;
 }

 
</style>
<script>
 //import axios from "axios";
 import axios from 'axios/dist/axios';
//import App from './App.svelte';
 export let visible;
 export let filename = "";
 let uploadActive = "";
 let uploadPercentage = 0;
 let progress = 0;

 export let af = { title: "", notes: "", itemid: "" };
 export let name;

 // const progress = tweened(0, {
 //   duration: 400,
 //   easing: cubicOut
 // });
 // $: console.log(`fu ${filename} v=${visible} t=${af.title} n=${af.notes}`);

 function changed(event) {
     let fileinput = event.target;
     console.log("changed event:",event);
     console.log("file  fi, fi.files", fileinput, fileinput.files[0]);
     let formData = new FormData();

     /*
        Add the form data we need to submit
      */
     formData.append("file", fileinput.files[0]);

     let endpoint =
         window.base +
         "cart/add_file_uploaded_file/" +
         window.cartid +
         "?sku=" +
         window.sku;
     let formobj = {
         cartid: window.cartid,
         shopperid: window.customer,
         itemid: af.itemid,
         output: "json"
     };
     //     console.log("endpoint", endpoint);
     let aap = document.getElementById("add-audio-page");
     if (aap){
        aap.classList.add("wait");
     }
     axios
         .post(endpoint,
               formData,
               {
                   headers: {
                       "Content-Type": "multipart/form-data"
                   },
                   onUploadProgress: function (progressEvent) {
                       //uploadPercentage = parseInt(
                       progress = Math.round((progressEvent.loaded / progressEvent.total)
                           * 100);
                                              console.log("progress21", progress, progressEvent);
                       //);
                   }
               })
         .then(function(e) {
             
             //        
            if (e && e.data && e.data.files) {


                Object.assign(af, e.data.files[0]);
                if (af.title) {af.title +=" ";}else{af.title ="";}
                if (af.notes) {af.notes +=" ";}else{af.notes ="";}

                if (af.name) {af.title += af.name;}
                if (af.description) {af.notes += af.description;}
                filename = baseName(af.url);
             }else{
                console.log("SUCCESS? ", e.data);
                //throw 'Malformed event data!' + e;
             }

             if (document.getElementById("add-audio-page")) {
                document.getElementById("add-audio-page").classList.remove("wait");
             }  

             visible = "";
             //             console.log("FU done2", af, af.duration, af.title, filename);
         })
         .catch(function(e) {
             console.log("FAILURE!!", e);
         });
 }

 function baseName(str) {
     var base = new String(str).substring(str.lastIndexOf("/") + 1);
     return base;
 }

 // function done() {
 //   $("#item_" + twid + "_uploads_queue").append(
 //     "<center>File '<b>" + file.name + "</b>' successfully uploaded!</center>"
 //   );
 //   $(selector + "  input.title").attr("value", file.name);
 //   $("#itemid_" + twid + "").val(file.itemid);
 //   $("#item_" + twid + "_uploads_btn").hide();
 //   SUCCEED: var link = $("<a>")
 //     .attr("target", "_blank")
 //     .prop("href", file.url);
 //   $("#item_" + twid + "_uploads_queue").append(link);
 //   FAIL: var error = $('<span class="text-danger"/>').text(
 //     "File upload failed for " + data.files[index].name + "."
 //   );
 //   $("#item_" + twid + "_uploads_queue")
 //     .append(error)
 //     .append("<br>");
 // }
</script>



<div class="form-group {visible ? '' : 'hidden'}">
 <label>Upload</label> <br>  
 <div class="custom-file ">
     <span class="control-fileupload input-group orange">
         <input name="wf_Uploadanaudiofile" type="file" class="form-control custom-file-input orange" id="customFile" on:change={changed} >
         <label class="custom-file-label" for="wf_Uploadanaudiofile">Choose file</label>
   </span>
     <input type="hidden" name="{name}.uploaded" value="" />
     <input type="hidden" name="{name}.carti" value="{af.itemid}" class="itemid"  />
    <div class="progress">        
        <progress class="progress-bar is-success" role="progressbar" max="100" min="0" value={progress}
        ></progress>
    </div>
  </div>
</div>
